// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse.attributeTypeMap;
    }
}
SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse.discriminator = undefined;
SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse.additionalProperties = false;
SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse.js.map